(($, Drupal) => {
  "use strict";

  // Disables the submit button for the single essay analysis form and
  // updates its text when clicked to indicate processing.
  const olexinstantSubmitBtn = (context) => {
    const formWrapper = context.querySelector(
      ".school-online-openai-single-essay-analysis-form"
    );
    if (!formWrapper) return;

    formWrapper.addEventListener("submit", () => {
      const submitButton = formWrapper.querySelector("#edit-submit");
      if (!submitButton) return;
      submitButton.classList.add("disabled");
      submitButton.textContent = Drupal.t("Analysing feedback");
      if (window.innerWidth <= 768) {
        $('#js-loading-screen').css('display', 'flex');
      }
      sessionStorage.removeItem("scrollRestore");
      sessionStorage.setItem("autoClickFirstRowAfterReload", "true");
    });
  };

  Drupal.behaviors.autoClickFirstRowAfterReload = {
    attach: function (context) {
      if (sessionStorage.getItem("autoClickFirstRowAfterReload") === "true") {
        sessionStorage.removeItem("autoClickFirstRowAfterReload");
        const $firstRow = $('#single-essay-analysis-history .view-single-essay-analysis-history table tbody tr').first();
        if ($firstRow.length) {
          setTimeout(() => {
            $firstRow.trigger("click");
          }, 0);
        }
      }
    }
  };

  // This function checks the select element and updates the checkbox accordingly
  // when the select element changes.
  const olexinstantEalCheck = (context) => {
    const selectElement = document.querySelector('#edit-eal-translation');
    const checkboxElement = document.querySelector('#edit-olexai-processes-translation');
    if (!selectElement || !checkboxElement) return;
    selectElement.addEventListener('change', function () {
      if (selectElement.value) {
        checkboxElement.checked = true;
      } else {
        checkboxElement.checked = false;
      }
    });
  };

  Drupal.behaviors.olexinstant = {
    attach(context) {
      olexinstantSubmitBtn(context);
      olexinstantEalCheck(context);
    },
  };
})(jQuery, Drupal);
